import { Button, List, Popconfirm, message } from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, ReadOutlined, BookOutlined } from "@ant-design/icons";
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { Link } from "react-router-dom";
import { usePDFStore } from "../Idb";
import { useSavingLoader } from "../../../Components/SavingLoader/SavingLoader";

export const Mybooks = () => {
    const [saved, setSaved] = useState([]);
    const { getPDFsFromIndexedDB, deletePDFFromIndexedDB } = usePDFStore();
    const loaderStore = useSavingLoader();

    useEffect(() => {
        loadBooks();
    }, []);

    const loadBooks = async () => {
        try {
            const books = await getPDFsFromIndexedDB();
            setSaved(books);
        } catch (error) {
            console.error("Kitoblarni yuklashda xatolik:", error);
            message.error("Kitoblarni yuklashda xatolik yuz berdi");
        }
    };

    const handleDelete = async (id) => {
        try {
            loaderStore.getState().showLoader("Kitob o'chirilmoqda...");
            await deletePDFFromIndexedDB(id);
            await loadBooks(); // Ro'yxatni yangilash
        } catch (error) {
            console.error("Kitobni o'chirishda xatolik:", error);
        } finally {
            loaderStore.getState().hideLoader();
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <h2 style={{ marginBottom: '20px' }}>
                <BookOutlined /> Mening Kitoblarim
            </h2>
            <List
                className="demo-loadmore-list"
                itemLayout="horizontal"
                dataSource={saved}
                locale={{ emptyText: 'Hozircha saqlangan kitoblar yo\'q' }}
                renderItem={(item) => (
                    <List.Item
                        style={{ 
                            backgroundColor: '#fff', 
                            padding: '20px', 
                            borderRadius: '10px', 
                            margin: '10px 0',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                        }}
                        actions={[
                            <Link to={'/mybook/' + item.id}>
                                <Button 
                                    type="primary" 
                                    icon={<ReadOutlined />}
                                >
                                    O'qish
                                </Button>
                            </Link>,
                            <Popconfirm
                                title="Kitobni o'chirish"
                                description="Haqiqatan ham bu kitobni o'chirmoqchimisiz?"
                                onConfirm={() => handleDelete(item.id)}
                                okText="Ha"
                                cancelText="Yo'q"
                            >
                                <Button 
                                    danger 
                                    type="primary"
                                    icon={<DeleteOutlined />}
                                >
                                    O'chirish
                                </Button>
                            </Popconfirm>
                        ]}
                    >
                        <List.Item.Meta
                            avatar={<BookOutlined style={{ fontSize: '24px', color: '#1890ff' }} />}
                            title={<span style={{ fontSize: '16px', fontWeight: 'bold' }}>{item.title}</span>}
                            description={<span style={{ color: '#666' }}>{item.author}</span>}
                        />
                    </List.Item>
                )}
            />
        </div>
    );
};
